import { useEditSceneModalStateContext } from './EditSceneModalStateContext';

export default function useIsEditorReady() {
  const {
    state: { isPreviewReady },
  } = useEditSceneModalStateContext();

  return {
    isReady: isPreviewReady,
  };
}
